import { FC, PropsWithChildren, ReactElement } from 'react'

import './InputLabel.scss'

interface InputLabelProps {
    text: string
    className?: string
    requiredClassName?: string
}

export const InputLabel: FC<PropsWithChildren<InputLabelProps>> = ({
    text,
    className = '',
    children,
}): ReactElement => (
    <div className={`input-label ${className}`}>
        {text}

        {children}
    </div>
)
